/* eslint-env browser */

import React from "react";
import PropTypes from "prop-types";
// import config from 'config';
// import request from 'superagent-bluebird-promise';check
import { Twemoji } from "react-emoji-render";
import moment from "moment";
import CircularProgressbar from "react-circular-progressbar";
import { cityFormat } from "util/cityFormat";
import { getCover } from "util/checkImage";
import WriteReview from "components/RestaurantDetails/WriteReview.js";
import { NavLink } from "react-router-dom";

function getCategoryColor(category) {
  let colorCategory = "rgb(117,126,161)";
  if (category) {
    switch (category) {
      case 1:
        colorCategory = "rgb(241,121,175)"; // Aperitivo after dinner
        break;
      case 2:
        colorCategory = "rgb(237,191,59)"; // Pub
        break;
      case 3:
        colorCategory = "rgb(95,198,196)"; // Pasticceria
        break;
      case 4:
        colorCategory = "rgb(186,196,124)"; // Gelateria
        break;
      case 5:
        colorCategory = "rgb( 117,126,161)"; // Osteria
        break;
      case 6:
        colorCategory = "rgb( 218,127,87)"; // Paninoteca
        break;
      case 7:
        colorCategory = "rgb(168,209,168)"; // Tavola Calda
        break;
      case 8:
        colorCategory = "rgb( 218,127,87)"; // Food Truck
        break;
      case 9:
        colorCategory = "rgb(123,95,124)"; // Pizzeria
        break;
      case 10:
        colorCategory = "rgb(117,126,161)"; // Ristorante
        break;
      case 11:
        colorCategory = "rgb(168,209,168)"; // Rosticceria
        break;
      case 12:
        colorCategory = "rgb(117,126,161)"; // NONE
        break;
      case 13:
        colorCategory = "rgb(117,126,161)"; // NONE
        break;
      case 14:
        colorCategory = "rgb(117,126,161)"; // Trattoria
        break;
      case 15:
        colorCategory = "rgb(241,121,175)"; // Wine Bar
        break;
      case 16:
        colorCategory = "rgb(117,126,161)"; // Agriturismo
        break;
      case 17:
        colorCategory = "rgb(241,121,175)"; // Coffee Bar
        break;
      case 18:
        colorCategory = "rgb(42,139,77)"; // Rifugio
        break;
      case 19:
        colorCategory = "rgb(42,122,139)"; // Stabilimento balneare
        break;
      case 20:
        colorCategory = "rgb(218,127,87)"; // Fast Food
        break;
      case 21:
        colorCategory = "rgb(117,126,161)"; // Bistrot
        break;
      case 22:
        colorCategory = "rgb(95,198,196)"; // Forno e Panetteria
        break;
      case 23:
        colorCategory = "rgb(184,147,174)"; // Barbecue
        break;
      case 24:
        colorCategory = "rgb(123,95,124)"; // Pizzeria al taglio
        break;
      case 25:
        colorCategory = "rgb(184,147,174)"; // Steakhouse
        break;
      case 26:
        colorCategory = "rgb(237,191,59)"; // Birreria
        break;
      case 27:
        colorCategory = "rgb(218,127,87)"; // Street Food
        break;
      // case 28: colorCategory = 'rgb(210,114,114)'; // Piadineria
      //   break;
      // case 29: colorCategory = 'rgb(188,167,120)'; // Sushi
      //   break;
      // case 30: colorCategory = 'rgb(125,61,61)'; // Bottega
      //   break;
      default:
        colorCategory = "rgb(117,126,161)";
        break;
    }
  }
  return colorCategory;
}

export default function Review(props) {
  function getCircleScore(type) {
    const review = props.review;
    console.log("review", review);
    // const color = getCategoryColor(
    //   review.category && review.category._id ? review.category._id : 0
    // );
    let percentage;
    let score;
    if (type === "price") {
      percentage = 100;
      score =
        review.price && !isNaN(review.price)
          ? `${Number(review.price).toFixed(0)}€`
          : "-";
    } else {
      const value = review.score.find(el => el.name === type);
      if (value && value.score) {
        percentage = value.score * 10;
        score = Number(value.score).toFixed(1);
      }
    }
    if (score >= 10) {
      score = "10";
    }
    return (
      <div className="RestaurantInfo-rating">
        <CircularProgressbar
          percentage={percentage}
          textForPercentage={() => score}
          initialAnimation
          className="RestaurantInfo-rating"
          styles={{
            text: {
              fontFamily: '"Archivo Black"',
              fontSize: "30px",
              fill: "#3c3c3b"
            },
            stroke: {
              backgroundImage: "linear-gradient(317deg, #96bb65, #28a159)"
            },
            path: {
              // stroke: color
            }
          }}
        />
      </div>
    );
  }

  const review = props.review;
  console.log(review);
  // const color = getCategoryColor(
  //   review.category && review.category._id ? review.category._id : 0
  // );
  const { url } = getCover(
    review.viewStyleSelected,
    review.photo,
    review.facebook,
    768
  );
  let score = "-";
  if (review.score && review.score.some(sc => sc.name === "total")) {
    score = Number(review.score.find(sc => sc.name === "total").score).toFixed(
      1
    );
    if (score >= 10) {
      score = "10";
    }
  }
  let city = "";
  if (review[`addressIT`]) {
    city = cityFormat(review[`addressIT`]);
  }
  const category =
    review.category && review.category[`label_it`]
      ? review.category[`label_it`]
      : "";
  let date = "";
  const dateDay = moment(review.checkInDate)
    .format("DD")
    .toString();
  const dateMonth = `${moment(review.checkInDate)
    .format("MM")
    .toString()}`;
  const dateYear = moment(review.checkInDate)
    .format("YYYY")
    .toString();
  date = `${dateDay}/${dateMonth}/${dateYear}`;
  return (
    <div className="last-reviews-profile-container">
      <div
        className="last-reviews-card-restaurant-image"
        style={{ backgroundImage: `url('${url}` }}
      />
      <div className="user-review-card-body">
        <div style={{ width: "100%", display: "inline-block" }}>
          <div className="last-reviews-card-name-and-food">
            <div
              className="last-reviews-card-name line-clamp line-clamp-2"
              style={{ textAlign: "left" }}
            >
              <NavLink
                to={`/restaurant?${review.alias}`}
                className="user-menu-link"
                // className={classes.itemLink + " " + classes.userCollapseLinks}
              >
                {review.name}
              </NavLink>
              {/* <a
                className="last-reviews-card-name"
                href={`/restaurant?${review.alias}`}
                title={`${review.name} ${category}`}
              >
                {review.name}
              </a> */}
            </div>
            {/* <div className="user-review-checkin-number">
              {review.checkInNumber} Check-in
            </div> */}
          </div>
          <div className="last-reviews-card-score-and-price">
            <div
              className="last-reviews-card-score"
              style={{
                //color,
                marginTop: "0"
              }}
            >
              {score}
            </div>
          </div>
        </div>
        {review.score ? (
          <div style={{ width: "100%", display: "flex" }}>
            <div
              style={{
                width: "290px",
                margin: "20px auto",
                display: "flex"
              }}
            >
              <div
                className="RestaurantInfo-rating-container"
                style={{ marginRight: "30px" }}
              >
                {getCircleScore("menu")}
                <div
                  style={{ marginTop: "15px" }}
                  className="RestaurantInfo-rating-menu"
                >
                  Menu
                </div>
              </div>
              <div
                className="RestaurantInfo-rating-container"
                style={{ marginRight: "30px" }}
              >
                {getCircleScore("location")}
                <div
                  style={{ marginTop: "15px" }}
                  className="RestaurantInfo-rating-menu"
                >
                  Location
                </div>
              </div>
              <div
                className="RestaurantInfo-rating-container"
                style={{ marginRight: "30px" }}
              >
                {getCircleScore("service")}
                <div
                  style={{ marginTop: "15px" }}
                  className="RestaurantInfo-rating-menu"
                >
                  Servizio
                </div>
              </div>
              <div className="RestaurantInfo-rating-container">
                <div className="RestaurantInfo-rating">
                  {getCircleScore("price")}
                </div>
                <div
                  style={{ marginTop: "15px" }}
                  className="RestaurantInfo-rating-menu"
                >
                  Prezzo
                </div>
              </div>
              {review.blob ? (
                <p className="last-reviews-card-text">
                  {'"'}
                  <Twemoji text={review.blob} />
                  {'"'}
                </p>
              ) : null}
            </div>
          </div>
        ) : (
          <WriteReview
            restaurantName={review.name}
            restaurant={review.restaurantId}
            checkInId={review.checkInId}
            user={props.user}
            setReview={reviewed => {
              props.setReview(reviewed);
              // console.log(rest.reviews);
            }}
            hideAlert={() => {}}
          />
        )}
        <div
          className="last-reviews-card-locality"
          style={{
            height: "40px",
            textAlign: "center",
            marginBottom: "20px"
          }}
        >
          {/* <div className="user-review-reviewed-as">
            Recensito{" il "}
            <span style={{ fontStyle: "italic" }}>{date}</span>
          </div> */}
          <div className="user-review-locality">{city}</div>
        </div>
        {review.text ? (
          <p className="last-reviews-card-text">
            {'"'}
            <Twemoji text={review.text} />
            {'"'}
          </p>
        ) : null}
        {review.ownerReply ? (
          <div style={{ marginTop: "15px" }}>
            <div style={{ width: "100%", display: "inline-block" }}>
              <div
                className="restaurant-detail-review-comment-madeBy"
                style={{ float: "left" }}
              >
                Risposta del proprietario
              </div>
            </div>

            <div className="restaurant-detail-review-comment">
              <Twemoji text={`${review.ownerReply}`} />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

Review.propTypes = {
  attributes: PropTypes.object.isRequired,
  review: PropTypes.object.isRequired
};
